<div class="container mx-auto px-5">
    <app-section-header i18n-text text="Version"></app-section-header>

    <div class="flex flex-col text-xs p-2">
        <span><ng-container i18n>Version</ng-container>: {{ version }}</span>
        <span><ng-container i18n>Build date</ng-container>: {{ gitVersion.buildDate | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
        <span><ng-container i18n>Commit</ng-container>: {{ gitVersion.commit }}</span>
    </div>
</div>
